import { UIEvent, useState } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { DangerButton, CancelButton } from 'components/Buttons';

import colors from 'styles/colors';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  background-color: ${colors.white};
  border-radius: 4px;
  overflow: hidden;
  transition: 0.15s opacity ease-in-out;
  padding: 24px;
  width: 368px;
  padding-top: 48px;
  ${(props) =>
    // @ts-expect-error TS(2339): Property 'loading' does not exist on type 'ThemedS... Remove this comment to see the full error message
    props.loading
      ? `
        opacity: 0.5;
    `
      : null};
`;

const Title = styled.div`
  text-transform: uppercase;
  font-size: 20px;
  line-height: 27px;
  font-weight: 700;
  margin-bottom: 16px;
  text-align: center;
`;

const Description = styled.div`
  margin-bottom: 16px;
  text-align: center;
`;

const ActionButtons = styled.div`
  display: flex;
  width: 100%;
  margin-top: 40px;

  & button {
    flex-grow: 1;
  }
`;

// eslint-disable-next-line import/prefer-default-export
export const RemoveModal = (props: {
  removedItemTitle: string;
  removedItemDescription: string | string[];
  confirmButtonLabel?: string;
  cancelCallback: () => void;
  confirmCallback: (e: UIEvent) => Promise<void>;
}) => {
  const intl = useIntl();

  const [loading, setLoading] = useState(false);

  const handleDelete = async (e: UIEvent) => {
    setLoading(true);
    await props.confirmCallback(e);
    setLoading(false);
  };

  return (
    <Container data-testid="RemoveModal">
      <Title>{props.removedItemTitle}</Title>
      {props.removedItemDescription instanceof Array ? (
        props.removedItemDescription.map((description, index) => <Description key={index}>{description}</Description>)
      ) : (
        <Description>{props.removedItemDescription}</Description>
      )}
      <ActionButtons>
        <CancelButton onClick={props.cancelCallback} />
        <DangerButton loading={loading} onClick={handleDelete}>
          {props.confirmButtonLabel ?? intl.formatMessage({ id: 'buttons.remove' })}
        </DangerButton>
      </ActionButtons>
    </Container>
  );
};
